<template>
  <div>
    <Space v-if="$store.state.control == 1">
      &nbsp;&nbsp;企业代码：
      <Input
        v-model="clientcode"
        @click="SelectClientSwitch = !SelectClientSwitch"
        placeholder="企业代码"
        style="width: 200px"
      />
      <br /><br />
    </Space>
    <Space>
      &nbsp;&nbsp;赋码范围：
      <Input
        v-model="minSerial"
        placeholder="开始物流码"
        style="width: 200px"
      />
      &nbsp;-&nbsp;
      <Input
        v-model="maxSerial"
        placeholder="结束物流码"
        style="width: 200px"
      /> </Space
    ><br /><br />
    <Space>
      &nbsp;&nbsp;字段ID：
      <Input
        v-model="filedId"
        @click="SelectFiledSwitch = !SelectFiledSwitch"
        placeholder="字段id"
        style="width: 200px"
      />
    </Space>
    <br /><br />
    <Space>
      &nbsp;&nbsp;是否启用：
      <Switch v-model="start" @on-change="change" />
    </Space>
    <br /><br />
    <Space>
      &nbsp;&nbsp;备注说明：
      <Input
        v-model="remark"
        type="textarea"
        :autosize="{ minRows: 2, maxRows: 5 }"
        placeholder="请输入说明..."
      ></Input>
    </Space>

    <div class="btn">
      <Button
        @click="updataAssign()"
        type="success"
        style="width: 100px; height: 40px"
        >保&nbsp;存</Button
      >
    </div>

    <transition name="fade">
      <SelectFiled
        v-if="SelectFiledSwitch"
        :FiledData="filedId"
        @close="SelectFiledclose()"
        @Value="FiledValue"
      ></SelectFiled>
    </transition>
    <transition name="fade">
      <SelectClient
        v-if="SelectClientSwitch"
        @Value="SelectClientVal"
        @close="SelectClientClose"
      ></SelectClient>
    </transition>
  </div>
</template>

<script>
import { UpdataAssignList } from "@/api/index";
import SelectFiled from "@/views/selectFiled";
import SelectClient from "@/views/selectClient";
export default {
  props: ["AssignDatas"],
  data() {
    return {
      maxSerial: "",
      minSerial: "",
      filedId: "",
      clientcode: "",
      index1: "",
      remark: "",
      start: false,
      SelectFiledSwitch: false,
      SelectClientSwitch: false,
    };
  },
  components: {
    SelectFiled,
    SelectClient,
  },
  watch: {
    // 获取父组件的props传值
    AssignDatas(add, old) {
      console.log(add.start);
      if (add.start == 1) {
        this.start = true;
      } else {
        this.start = false;
      }
      this.remark = add.remark;
      this.minSerial = add.minSerial;
      this.maxSerial = add.maxSerial;
      this.filedId = add.filedId;
      this.clientcode = add.clientCode;
    },
  },
  methods: {
    SelectClientClose() {
      this.SelectClientSwitch = false;
    },
    SelectClientVal(value) {
      this.clientcode = value;
      this.SelectClientSwitch = false;
    },
    SelectFiledclose() {
      this.SelectFiledSwitch = false;
    },
    FiledValue(value) {
      this.filedId = value;
    },
    updataAssign() {
      UpdataAssignList({
        id: this.AssignDatas.id,
        maxSerial: this.maxSerial,
        minSerial: this.minSerial,
        filedId: this.filedId,
        clientcode: this.clientcode,
        start: this.start,
        remark: this.remark,
      }).then((res) => {
        if (res) {
          this.$emit("updataAssignResult", true);
          this.$Notice.success({ title: "修改成功！" });
        }
        // console.log(res);
      });
    },
  },
};
</script>

<style scoped>
body {
  padding: 0;
  margin: 0;
}
.btn {
  width: calc(100% - 20px);
  height: 100px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /* position: absolute;
  bottom: 0; */
}
</style>
